import { z } from "zod";
import { baseHeaderSchema } from "./base-definition";

export const numberSchema = baseHeaderSchema.extend({
  type: z.literal("number"),
  placeholder: z.string().optional(),
  defaultValue: z.preprocess((val) => {
    if (val === "" || val === undefined || val === null) return undefined;
    if (typeof val === "number") return val;
    if (typeof val === "string") {
      const parsed = Number(val);
      return Number.isNaN(parsed) ? val : parsed;
    }
    return val;
  }, z.number().optional()),
  required: z.boolean().optional().default(false),
});
export type NumberType = z.infer<typeof numberSchema>;
